import { RootComponentInstance } from "@uniformdev/canvas";

import { UniformPreviewPageTemplate } from "../../templates/uniform-preview/uniform-preview-page/src";

export type UniformPreviewPageProps = {
    composition: RootComponentInstance;
    isUniformPlayground?: boolean;
    isAllowPostMessage?: boolean;
};
export const UniformPreviewPage = ({
    composition,
    isUniformPlayground,
    isAllowPostMessage
}: UniformPreviewPageProps) => (
    <UniformPreviewPageTemplate
        composition={composition}
        isUniformPlayground={isUniformPlayground}
        isAllowPostMessage={isAllowPostMessage}
    />
);
